import { createTypes } from '../../utils';

const types = createTypes('backToTop', [
    'SHOW_BACK_TO_TOP_BUTTON',
    'HIDE_BACK_TO_TOP_BUTTON'
]);

export default types;
